var _path, _path2, _ellipse, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4898 4.02767C32.0507 1.32412 35.953 1.32411 37.5139 4.02766L65.1418 51.8806C66.7027 54.5842 64.7516 57.9637 61.6298 57.9637H6.3739C3.2521 57.9637 1.30096 54.5842 2.86186 51.8807L30.4898 4.02767Z",
    fill: "#FFF6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7973 19.8798L37.5243 4.00944C35.954 1.32211 32.067 1.33222 30.5108 4.02767L2.86186 51.917C1.30096 54.6206 3.2521 58 6.3739 58H61.6298C64.7516 58 66.7027 54.6205 65.1418 51.917L54.6057 33.668",
    stroke: "#FFA825",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8517,
    cy: 44.8341,
    rx: 1.5311,
    ry: 1.5311,
    transform: "rotate(-180 33.8517 44.8341)",
    fill: "#FFA825"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.3828,
    y: 39.8223,
    width: 3.0622,
    height: 15.9234,
    rx: 1.5311,
    transform: "rotate(-180 35.3828 39.8223)",
    fill: "#FFA825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.480cf210bd26ab686a39db640515e735.svg";
export { ForwardRef as ReactComponent };